<template>
  <div id="overlay">
    <div id="content" class="z-10 flex justify-around w-10/12 mt-20 bg-theme-white rounded-md drop-shadow-lg relative">
      <button
        class="border border-bd-gray rounded drop-shadow-lg absolute right-2 top-2 hover:border-bd-orange transition uration-300"
        @click="$emit('close')">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:text-txt-orange transition uration-300" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div v-show="img_flag === 0" class="w-325 py-8">
        <img :src="img_path + viewItem.web_img01" class="">
      </div>
      <div v-show="img_flag === 1" class="w-325 py-8">
        <img :src="img_path + viewItem.web_img02" class="">
      </div>
      <div v-show="img_flag === 2" class="w-325 py-8">
        <img :src="img_path + viewItem.web_img03" class="">
      </div>
      <div v-show="img_flag === 3" class="w-325 py-8">
        <img :src="img_path + viewItem.web_img04" class="">
      </div>
      <div class="p-10">
        <p class="text-lg text-txt-gray">{{ viewItem.product_name }}</p>
        <p class="text-sm text-txt-gray">メーカー：{{ viewItem.maker_name }}</p>
        <p class="text-base text-txt-gray pt-4">商品コード：{{ viewItem.ichioshi_product_code }}</p>
        <p class="text-base text-txt-gray pt-1 pb-4">品番：{{ viewItem.Product_number }}</p>
        <div class="flex">
          <article class="w-16 h-16 m-1">
            <img v-if="viewItem.web_img01 === ' ' || viewItem.web_img01 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_01" :src="img_path + viewItem.web_img01">
          </article>
          <article class="w-16 h-16 m-1">
            <img v-if="viewItem.web_img02 === ' ' || viewItem.web_img02 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_02" :src="img_path + viewItem.web_img02">
          </article>
          <article class="w-16 h-16 m-1">
            <img v-if="viewItem.web_img03 === ' ' || viewItem.web_img03 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_03" :src="img_path + viewItem.web_img03">
          </article>
          <article class="w-16 h-16 m-1">
            <img v-if="viewItem.web_img04 === ' ' || viewItem.web_img04 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_04" :src="img_path + viewItem.web_img04">
          </article>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router'
import axios from 'axios'
import { search_json } from '@/json.config.js';

export default {
  name: 'Modal',
  props: {
    flag: Number
  },
  setup(props) {
    // console.log(props)
    const route = useRoute()
    // const category_param = ref(route.query.webcat_view)
    let group_id = ref('')
    // const cassette_block_id = ref('')
    // let url = ref('') 
    const img_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/";

    // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search2023_so.json"

    const img_flag = ref()
    watchEffect(() => {
      const checkFlag = () => {
        switch (props.flag) {
          case 0:
            img_flag.value = 0;
            break
          case 1:
            img_flag.value = 1;
            break
          case 2:
            img_flag.value = 2;
            break
          case 3:
            img_flag.value = 3;
            break
        }
      }
      checkFlag()
      // console.log(img_flag)
    })

    const viewItem = ref({
      product_name: '',
      maker_name: '',
      ichioshi_product_code: '',
      Product_number: '',
      web_img01: '',
      web_img02: '',
      web_img03: '',
      web_img04: '',
      cassette_block_name: '',
    })

    watchEffect(() => {
      const ichioshi_product_code = ref(route.query.ichioshi_product_code)
      const modal_data = ref([])
      group_id.value = route.query.cassette_id
      // url = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=product&webcat_view="+category_param.value+"&cassette_id="+group_id.value;

      async function getitems() {
        // viewItem.value.data = await axios.get(url)
        const all_data = await axios.get(search_json)
        modal_data.value = []
        all_data.data.forEach(function (value) {
          if (value.ichioshi_product_code === ichioshi_product_code.value) {
            modal_data.value.push(value)
          }
        })

        viewItem.value.items = modal_data.value
        viewItem.value.product_name = viewItem.value.items[0].product_name
        viewItem.value.maker_name = viewItem.value.items[0].maker_name
        viewItem.value.ichioshi_product_code = viewItem.value.items[0].ichioshi_product_code
        viewItem.value.Product_number = viewItem.value.items[0].Product_number
        viewItem.value.web_img01 = viewItem.value.items[0].web_img01
        viewItem.value.web_img02 = viewItem.value.items[0].web_img02
        viewItem.value.web_img03 = viewItem.value.items[0].web_img03
        viewItem.value.web_img04 = viewItem.value.items[0].web_img04
        viewItem.value.cassette_block_name = viewItem.value.items[0].cassette_block_name
      }
      getitems()

    })

    const clk_img_01 = () => {
      img_flag.value = 0
    }
    const clk_img_02 = () => {
      img_flag.value = 1
    }
    const clk_img_03 = () => {
      img_flag.value = 2
    }
    const clk_img_04 = () => {
      img_flag.value = 3
    }

    return {
      img_path,
      img_flag,
      viewItem,
      // getItem,
      clk_img_01,
      clk_img_02,
      clk_img_03,
      clk_img_04
    }

  }

}
</script>

<style>
#overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
